<div class="qr-modal">
  <div class="qr-modal__text">Покажите QR-код на кассе</div>
  <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
  @if (useNewQrEnableFlag$ | async) {
    <sd-update-qr-button></sd-update-qr-button>
  }
</div>
